import { ATTACH_CLIENT_DOCUMENT, CHECK_DUPLICATE_CLIENT, PUBLISH_DOCUMENT, RESEND_CLIENT_REPORT, UPDATE_CLIENT_EXPIRY } from "config/apiPaths";
import { CLIENT_TYPE_KEYS } from "config/constants";
import { generatePath } from "react-router-dom";
import { baseApi } from "utils/axios/baseApi";
import { schoolClientsApi } from "./clients/school.client";
import { invalidateClientList } from "./clients/invalidateClientList";
import { invalidateAPITags } from "utils/common";

export const client = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // create note
    getClientDetails: builder.query({
      query: ({ clientType, clientId }) => ({
        method: "GET",
        url: `/client/${clientType}/view/${clientId}`,
      }),
      transformResponse: (response) => {
        return response.data;
      },
    }),
    checkDuplicateClient: builder.mutation({
      query: ({ clientType, data }) => ({
        method: "POST",
        url: generatePath(CHECK_DUPLICATE_CLIENT, { clientType }),
        data,
      }),
    }),
    attachDocument: builder.mutation({
      query: ({ clientId, data }) => ({
        method: "PUT",
        url: `${ATTACH_CLIENT_DOCUMENT}/${clientId}`,
        data
      })
    }),

    updateClientExpiry: builder.mutation({
      query: ({ clientId, clientType, data }) => ({
        method: "PUT",
        url: generatePath(UPDATE_CLIENT_EXPIRY, { clientId, clientType }),
        data
      })
    }),

    resendClientReport: builder.mutation({
      query: ({ payload, id }) => ({
        method: "PUT",
        url: `${RESEND_CLIENT_REPORT}/${id}`,
        data: payload
      }),
    }),


    updateClientStatus: builder.query({
      query: ({ clientId, clientType, status }) => ({
        method: "GET",
        url: `/client/${clientType}/${clientId}/${status}`,
      }),
      // invalidatesTags: (result, error, { clientId, clientType }) => {
      //   switch (clientType) {
      //     case CLIENT_TYPE_KEYS.school:
      //       return ["Schools"];
      //   }
      // },
      // onQueryStarted: async ({ clientType }, { dispatch, queryFulfilled }) => {
      //   let tags = [];
      //   switch (clientType) {
      //     case CLIENT_TYPE_KEYS.school:
      //       tags = ["SchoolClients"];
      //   }
      //   invalidateAPITags(queryFulfilled, dispatch, schoolClientsApi, tags);
      // },
    }),

    // Bulk status change from the clinician detail page client tabs
    bulkChangeClientStatus: builder.mutation({
      query: ({ clientType, client_ids, status }) => ({
        method: "PATCH",
        url: `/client/${clientType}/bulk/status`,
        data: { client_ids, status },
      }),
      onQueryStarted: async ({ clientType }, { dispatch, queryFulfilled }) => {
        invalidateClientList(queryFulfilled, dispatch, clientType);
      },
    }),

    publishDocument: builder.mutation({
      query: ({ clientId, resourceId }) => ({
        method: "PUT",
        url: `${PUBLISH_DOCUMENT}/${clientId}/${resourceId}`
      })
    }),

    getClientReportPublishHistory: builder.query({
      query: ({ clientId, resourceId }) => ({
        method: "GET",
        url: `/client/report-publish-history/${clientId}/${resourceId}`,
      }),
      transformResponse: (response) => response?.data || response,
    }),

  }),
})

export const {
  useGetClientDetailsQuery,
  useCheckDuplicateClientMutation,
  useAttachDocumentMutation,
  useUpdateClientExpiryMutation,
  useLazyUpdateClientStatusQuery,
  useResendClientReportMutation,
  usePublishDocumentMutation,
  useGetClientReportPublishHistoryQuery,
  useBulkChangeClientStatusMutation
} = client;
